/**
 * region for libraries*/
import React, { Component } from 'react';

export class WorkingLayer extends Component {
    static displayName = WorkingLayer.name;

    constructor(props) {
        super(props);
        this.state = {
            text: props.text || 'Loading'
        };
    }
    render() {
        return (<div className="loading-container">
            <div className="loading"><i className="fas fa-spinner fa-spin"></i> {this.state.text}…</div>
        </div>);
    }
}


